module.exports = __webpack_public_path__ + "10a515bf380fdf162f722cafa5594057.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-princess-snowhite.svg
// module id = 480
// module chunks = 0